import React, { useCallback, useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CustomTable from '../../components/customTable';
import getEnvironement from '../../../environnement';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import UpdateDialog from './components/updateDialog';
import DeleteDialog from './components/deleteDialog';
import CustomBackdrop from '../../../components/backdrop';
import AddDialog from './components/addDialog';

export default function Commentaire() {
  const [commentaires, setCommentaires] = useState([]);
  const [filtredCommentaires, setFiltredCommentaires] = useState(commentaires);
  const [selectedCommentaire, setSelectedCommentaire] = useState();
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const getCommentaires = useCallback(async () => {
    setIsLoader(true);
    const url = `${getEnvironement().API_URL}/commentaires`;
    await axios.get(url)
      .then((res) => setCommentaires(res.data.commentaires))
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }, []);

  useEffect(() => {
    setFiltredCommentaires(commentaires);
  }, [commentaires]);

  useEffect(() => {
    getCommentaires();
  }, [getCommentaires]);

  return (
    <div className='flex flex-col h-full'>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <UpdateDialog
        open={openUpdateDialog}
        handleOpen={() => setOpenUpdateDialog(true)}
        handleClose={() => setOpenUpdateDialog(false)}
        reloadData={getCommentaires}
        commentaireData={selectedCommentaire}
      />
      <DeleteDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        reloadData={getCommentaires}
        commentaireData={selectedCommentaire}
      />
      <AddDialog
        open={openAddDialog}
        handleOpen={() => setOpenAddDialog(true)}
        handleClose={() => setOpenAddDialog(false)}
        reloadData={getCommentaires}
      />
      <div className='sm:grid grid-cols-4 items-center gap-5'>
        <div className='border-2 border-primary rounded-[20px] flex mb-5 items-center col-start-1 col-end-3 xl:col-end-4'>
          <SearchIcon sx={{color: '#A31732', marginLeft: '20px'}} fontSize='large'/>
          <input
            placeholder='Chercher par commentaire'
            className='w-full font-inter font-medium text-2xl my-2 mx-5 focus:outline-none'
            onChange={(e) => {
              setFiltredCommentaires(commentaires.filter(commentaire => commentaire.commentaire.includes(e.target.value)));
            }}
          />
        </div>
        <div
          className='group rounded-[20px] py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark col-start-3 xl:col-start-4 col-end-5'
          onClick={() => setOpenAddDialog(true)}
        >
          <p className='font-medium px-2 text-xl w-full text-center text-white'>Ajouter un commentaire</p>
        </div>
      </div>
      <div className='flex-grow h-[48vh]'>
        <CustomTable
          headers={[
            'ID',
            'Commentaire',
            'Commentaire (En)',
            'Actions'
          ]}
          config
        >
          <tbody>
            {
              filtredCommentaires.map((item, index) => {
                return (
                  <tr key={index} className='border-b-2 border-gray'>
                    <td className='text-center font-medium text-xl py-2'>{item.id}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.commentaire}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.commentaire_en}</td>
                    <td className='text-center font-medium text-xl py-2'>
                      <div className='flex justify-center items-center'>
                        <Tooltip title="Modifier le matériel">
                          <IconButton onClick={() => {
                            setSelectedCommentaire(item);
                            setOpenUpdateDialog(true);
                          }}
                          >
                            <EditIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Supprimer le matériel">
                          <IconButton onClick={() => {
                            setSelectedCommentaire(item);
                            setOpenDeleteDialog(true);
                          }}
                          >
                            <DeleteIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
            }
            {filtredCommentaires.length === 0 && (
              <div className='border-dashed border-4 border-primary rounded-[30px] p-5 hidden xl:inline-block fixed mx-10 my-8 w-[65vw] md:w-[80vw] lg:w-[85vw]'>
                <p className='font-inter text-primary font-bold text-xl text-center'>
                  {isLoader ? (<CircularProgress open={isLoader} sx={{color: '#A31732'}}/>) : 'Aucun commentaire'}
                </p>
              </div>
            )}
          </tbody>
        </CustomTable>
      </div>
    </div>
  );
}
